import React, { useState, useEffect } from "react";
import "./style.scss";
import { Grid, Layout, PageHeader, Spin } from "antd";
import R2Footer from "../../components/Footer";
import TableConfiguration from "./TableConfiguration";
import PosService from "../../services/PosService";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import EmployeeService from "../../services/EmployeeService";
import Spinner from "../../components/Layout/Spinner";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const SeatingManagement = ({isFromAddPopup = false,addedTables,selectedTable,selectAllTables}) => {
  const adminRestaurant = useSelector((state) => state.admin);

  const [tableData, setTableData] = useState();
  const [waitlist, setWaitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [servers, setServers] = useState([]);
const screens = useBreakpoint();

  useEffect(() => {
    getSectionAndTablesData();
  }, [adminRestaurant]);

  const getSectionAndTablesData = async () => {
    setLoading(true)
    const sectionsFilter = await PosService.getSections(adminRestaurant);
    const sectiondata = sectionsFilter.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.floor === value.floor
    ))
  )
    const tabledata = await PosService.getTables(adminRestaurant);
    // const data = await PosService.getSectionTableMapping(adminRestaurant);
    const dataWaitlist = await PosService.posWaitlist(adminRestaurant);
    setWaitList(dataWaitlist?.waitlist)

    const dataServer = await EmployeeService.getEmployeesByEmployeeType("SERVER");
    setServers(dataServer.employees)
    
    setLoading(false)
    const colorsBorder= ['aqua', 'black', 'blue', 'fuchsia', 'gray', 'green', 
    'lime', 'maroon', 'navy', 'olive', 'orange', 'purple', 'red', 
    'silver', 'teal', 'white', 'yellow'];
       
        const occupancyData = tabledata?.map((item,i)=>{
          const obj ={
            occupancy:item.occupancy,
            number_of_table: item.number_of_table,
            paddingRight : 2 * item.occupancy+"px",
            id:item.id,
            color: colorsBorder[i]? colorsBorder[i]:'red'
          }
          return obj;
        })
        
        
       
        const tabledataRestaurent = await PosService.getRestaurentTablesForSeating(adminRestaurant);
        const floorData = sectiondata?.map(item=>{
          let dataSec =[];
          const floorFilter = sectionsFilter.filter(flooritem=>item.floor == flooritem.floor);
      for (var j = 0; j < floorFilter.length; j++) {
          
            const obj={
             
              id:floorFilter[j].id,
              section_id: item.id,
              sections:tabledataRestaurent.filter(itemTable=>itemTable.floor == item.floor ).map((itemmap,i)=>{

                if(itemmap.section_id == floorFilter[j].id)
                {
                const newItem = {id: itemmap.id, text: itemmap.table_type?.occupancy,color: colorsBorder[i],
                  paddingRight: 2 * item.table_type?.occupancy+"px", table_number:itemmap.table_number,
                  table_label:i+1}
                  return newItem
                }
    
              }).filter(itemundefined=> item != undefined)
            
          }
           dataSec.push(obj)
          }
          const obj ={
            floor:item.floor,
            name: item.name,
            id:item.id,
            sectionsMap:dataSec
          }
          return obj;
        });
        setTableData({
          sectionData:floorData,
            tableData: occupancyData,
        })
  };



  const [sectionMapping, setSectionMapping] = useState([]);

  return (
    <Layout style={{ padding: "0 0px 0px", background: "#eeeded" }}>
      <Content
        className="site-layout-background"
        style={{
          padding: isFromAddPopup? "0px 0px": "0px 24px",
          margin: isFromAddPopup? "0px 0px":"16px 0px",
          minHeight: 280,
          background: "#eeeded",
        }}
      >
        
        <div style={{ marginTop: (!isFromAddPopup && screens.md) && "2rem" }}>
        <div style={{ marginTop: (!isFromAddPopup && screens.md) && "2rem" }}>
          {tableData &&
            <TableConfiguration
              restaurant_id={adminRestaurant}
              tableData={tableData}
              waitlist={waitlist}
              servers = {servers}
              isFromAddPopup = {isFromAddPopup}
              addedTables = {addedTables}
              selectedTable={selectedTable}
              selectAllTables = {selectAllTables}
              // sectionMapping={sectionMapping}
              // setSectionMapping={setSectionMapping}
            />
          }
          </div>
        </div>
      </Content>
      {
                        loading &&
                            <Spinner/>
      }
      {!isFromAddPopup &&
      <R2Footer />}
    </Layout>
  );
};

export default SeatingManagement;
